<template>
  <div class="row animated fadeIn">
    <div class="col-md-8 offset-md-2">
      <div class="card">
        <div class="card-header">
          <i class="fa fa-align-justify"></i>
          <strong>Lista de Decisions</strong>
          <router-link :to="'decisions/new'" class="btn btn-secondary btn-sm pull-right" exact>
            <i class="fa fa-plus"></i> Nova Decision
          </router-link>
        </div>
        <div class="card-block">
          <table class="table table-bordered">
            <thead class="thead-inverse">
              <tr>
                <th>Decision</th>
                <th>Última Atualização</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, rowIndex) in orderedItems" :key="row.id">
                <td>
                  <router-link :to="'decisions/' + row.id">{{ row.name }}</router-link>
                </td>
                <td>{{row.lastUpdate | formatDate}}</td>
                <td class="actions">
                  <button type="button" class="btn btn-link" @click="showTestModal(row)">
                    <i class="fa fa-play-circle"></i>
                  </button>
                  <router-link :to="'decisions/versions/' + row.id">
                    <button title="Visualizar Versoes" type="button" class="btn btn-link">
                      <i class="fa fa-navicon"></i>
                    </button>
                  </router-link>
                  <button title="Remover" type="button" class="btn btn-link" @click="showModal(row)">
                    <i class="fa fa-trash"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>

          <!--Modal remover decision -->
          <modal title="Modal title" class="modal" v-model="deleteModal" @ok="deleteModal = false" effect="fade/zoom">
            <div slot="modal-header" class="modal-header">
              <span class="modal-title">
                <strong>Excluir Decision</strong>
              </span>
            </div>
            <div slot="modal-body" class="modal-body">Deseja excluir a decision
              <strong>{{ decision.identifier }}</strong>?
            </div>
            <div slot="modal-footer" class="modal-footer">
              <button type="button" class="btn btn-sm btn-default" @click="deleteModal = false">Cancelar</button>
              <button type="button" class="btn btn-sm btn-danger" @click.prevent="deleteItem">Confirmar</button>
            </div>
          </modal>
        </div>
      </div>
    </div>

    <!--Modal de teste -->
    <modal title="Modal title" class="modal" v-model="testModal" effect="fade/zoom">
      <div slot="modal-header" class="modal-header">
        <span class="modal-title">
          <strong>{{testDecision.identifier}}</strong>
        </span>
      </div>
      <div slot="modal-body" class="modal-body">
        <div class="card">
          <div class="card-header">
            <strong class="pull-left">Variáveis de entrada</strong>
            <button type="button" class="btn btn-sm btn-secondary pull-right" @click="executeTest">Executar</button>
          </div>
          <div class="card-block">
            <vue-json-editor v-model="testDecisionHeaders" mode="code" :showBtns="false"></vue-json-editor>
          </div>
        </div>
        <div class="clearfix" />
        <div v-show="testExecuted">
          <div v-show="testResult.length > 0">
            <div class="card">
              <div class="card-header">
                Resultado
              </div>
              <div class="card-block testResult">
                <div v-for="(row, rowIndex) in testResult" :key="row">
                  <pre>{{row}}</pre>
                </div>
              </div>
            </div>
          </div>
          <div v-show="testResult.length == 0">
            <br/>
            <p>Nenhum resultado encontrado </p>
          </div>
        </div>
      </div>
      <div slot="modal-footer" class="modal-footer">
        <button type="button" class="btn btn-sm btn-default" @click="testModal = false">Fechar</button>
      </div>
    </modal>

  </div>
</template>
<script>
import modal from 'vue-strap/src/Modal'
import axios from 'axios'
import vueJsonEditor from 'vue-json-editor'

export default {
  name: 'decisions',
  components: {
    modal, vueJsonEditor
  },
  data() {
    return {
      deleteModal: false,
      testModal: false,
      testExecuted: false,
      testResult: [],
      testDecisionHeaders: {},
      decision: {},
      testDecision: {
        inputHeaders: []
      },
      decisions: []
    }
  },
  computed: {
    orderedItems: function() {
      return this.decisions.sort((a, b) => {
        return Date.parse(b.lastUpdate) - Date.parse(a.lastUpdate)
      })
    }
  },
  created() {
    this.loadItems()
  },
  methods: {
    deleteItem() {
      this.deleteModal = false
      axios.delete(process.env.BEAST_MANAGER_API_URL + 'decisions/' + this.decision.id).then(response => {
        this.showSuccess('Decision excluida com sucesso!')
        this.loadItems()
      }).catch(err => {
        console.error(err)
        this.showError('Ops. Ocorreu um erro ao excluir a decision.')
      })
    },
    loadItems() {
      axios.get(process.env.BEAST_MANAGER_API_URL + 'decisions').then(response => {
        this.decisions = response.data
      }).catch(err => {
        console.log(err)
        this.showError('Ops. Ocorreu um erro ao carregar as decisions.')
      })
    },
    showModal(item) {
      this.decision = item
      this.deleteModal = true
    },
    showTestModal(item) {
      this.testDecision = item
      this.testExecuted = false
      this.testDecisionHeaders = item.inputHeaders.map(function(item) {
        return { 'key': item, 'value': '' }
      }).reduce(function(total, current) {
        total[current.key] = current.value
        return total
      }, {})
      this.testModal = true
    },
    executeTest(item) {
      this.testExecuted = false
      axios.post(`${process.env.BEAST_SERVER_API_URL}decisions/${this.testDecision.id}/process`, this.testDecisionHeaders).then(response => {
        this.testResult = response.data.outputs
        this.testExecuted = true
      }).catch(err => {
        console.log(err)
        this.showError('Ops. Ocorreu um erro ao testar a decision.')
      })
    }
  }
}
</script>
<style>
.jsoneditor-vue div.jsoneditor-tree {
  min-height: 150px !important
}

.testResult {
  max-height: 200px;
  overflow-y: auto
}
</style>



// WEBPACK FOOTER //
// Index.vue?20a4642d